import { BaseForm } from '@app/components/common/forms/BaseForm/BaseForm';
import * as Auth from '@app/components/layouts/AuthLayout/AuthLayout.styles';
import { Button, Input } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AddRoleDataProps } from '../AddRoleModal';
import * as S from './AddRoleForm.styles';

export const AddRoleForm: React.FC<AddRoleDataProps> = ({ loading, onFinish }) => {
  const { t } = useTranslation();
  const [form] = BaseForm.useForm();

  return (
    <BaseForm form={form} name="addRole" onFinish={onFinish} validateTrigger="onBlur">
      <S.ContentWrapper>
        <S.BlockWrapper>
          <S.Label> {t('roles.form.addRole')}</S.Label>
          <Auth.FormItem
            name="role"
            label={t('roles.form.role')}
            hasFeedback
            rules={[{ required: true, message: t('roles.form.roleRequired') }]}
          >
            <Input placeholder={t('roles.form.role')} />
          </Auth.FormItem>
        </S.BlockWrapper>

        <BaseForm.Item>
          <Button type="primary" htmlType="submit" block disabled={loading}>
            {t('common.save')}
          </Button>
        </BaseForm.Item>
      </S.ContentWrapper>
    </BaseForm>
  );
};
